import ReactDOM from 'react-dom/client'
import { CoorumResearchApp } from '../components/CoorumResearchApp'
import { type RenderResearchComponentProps, showResearchPage } from '../components/PageStoreProvider'
import { canDisplayPopup, setLauncherDisplayMode, setResearchRootPositionAndHeight } from './render-research.util'

let researchRoot: ReactDOM.Root | null = null

export function getResearchReactRootContainer() {
  return window.parent.document.querySelector<HTMLElement>('#cr-research-container')
}

function getResearchReactRoot() {
  const researchRootEl = window.document.querySelector<HTMLElement>('#root')!
  researchRootEl.style.height = canDisplayPopup() ? '100%' : 'calc(100% - 32px)'
  if (!researchRoot) {
    researchRoot = ReactDOM.createRoot(researchRootEl)
  }
  return researchRoot
}


function getResearchReactCreateRoot() {
  const researchContainerEl = getResearchReactRootContainer()
  if (!researchContainerEl) {
    console.error('researchContainerEl not found')
    return
  }
  researchContainerEl.setAttribute('style', 'display:block;') // style="display:none;" を blockにする

  const researchRoot = getResearchReactRoot()
  researchRoot.render(<CoorumResearchApp />)

  return researchRoot
}

export function renderResearchPage(props: RenderResearchComponentProps) {
  // researchContainerEl
  const researchContainerEl = getResearchReactRootContainer()
  if (!researchContainerEl) {
    console.error('researchContainerEl not found')
    return
  }

  // researchRoot
  const researchReactRoot = getResearchReactCreateRoot()
  if (!researchReactRoot) {
    console.error('researchReactRoot not found')
    return
  }

  const displayMode = setLauncherDisplayMode(researchContainerEl)
  if (displayMode === 'popup') {
    setResearchRootPositionAndHeight(researchContainerEl, props.popup?.configJson)
  }

  showResearchPage(researchContainerEl, props)
}
